export const website = {
  firstStep: {
    title: "¡Empecemos! ¿Qué plantilla quieres usar?",
    subtitle:
      "¿Listo para crear una web espectacular? Empecemos por las plantillas; después pasaremos a los colores.",
  },
  secondStep: {
    title: "¿Qué gama de colores se ajusta mejor a tu marca?",
    subtitle: "Personaliza tu plantilla con un toque de color",
  },
  thirdStep: {
    title: "¿Tienes buenas fotos de tu alojamiento?",
    titleLine2: "¡Súbelas!",
    subtitle: "Sube la mejor foto de tu alojamiento para la página principal",
  },
  fourthStep: {
    title: "Muy bien. ¿Qué tal un nombre para tu negocio?",
    subtitle:
      "El nombre y el eslogan de una empresa mejoran el reconocimiento y refuerzan tu imagen de marca.",
  },
  fifthStep: {
    title: "¿Tienes un logo para tu marca?",
    subtitle:
      "Para obtener los mejores resultados, utiliza un diseño vectorial o PNG con fondo transparente. Las proporciones ideales son 2:1 o 1:1 (imagen cuadrada). El tamaño debe ser de 400px x 192px (altura mín. 60px). Si aún no tienes un logo, utilizaremos el nombre de tu negocio como marca.",
  },
  livingstone: {
    navMain: "Menú principal",
    navProperty: "Propiedad",
    navMap: "Mapa",
    navGallery: "Galería",
    navRates: "Tarifas",
    navAvailability: "Disponibilidad",
    navReviews: "Reseñas",
    bookNow: "Reservar ahora",
    checkinCheckout: "Llegada → Salida",
    guests: "Huéspedes",
  },
  tideway: {
    navMain: "Menú principal",
    navProperty: "Propiedad",
    navMap: "Mapa",
    navGallery: "Galería",
    navRates: "Tarifas",
    navAvailability: "Disponibilidad",
    navReviews: "Reseñas",
    bookNow: "Reservar ahora",
    checkinCheckout: "Llegada → Salida",
    guests: "Huéspedes",
  },
};
